import React, { useState } from "react";
import { auth } from "../firebase";
import { createUserWithEmailAndPassword, updateProfile, sendEmailVerification, signOut } from "firebase/auth";
import { Link } from "react-router-dom";
import "./Auth.css";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState(""); // For success message

  const handleSignup = async (e) => {
    e.preventDefault();
    // Basic client-side validation
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      setMessage("");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      // Update Firebase Auth profile with name
      await updateProfile(userCredential.user, {
        displayName: name,
        photoURL: ""
      });

      // Send verification email
      await sendEmailVerification(userCredential.user);

      // Sign out immediately effectively forcing them to verify before "logging in" properly
      // or at least before we create their profile in AuthContext
      await signOut(auth);

      setMessage("Account created! Please check your email to verify your account before logging in.");
      setError("");
      // Optionally navigate to login after a delay or let them click the link
      // navigate("/login"); 
    } catch (err) {
      setError(err.message);
      setMessage("");
    }
  };

  return (
    <div className="auth-container">
      <h2>Sign Up</h2>
      {error && <div className="auth-error">{error}</div>}
      {message && <div className="auth-success">{message}</div>}
      <form onSubmit={handleSignup} style={{ width: "100%" }}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={e => setName(e.target.value)}
          autoComplete="name"
          required 
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          autoComplete="new-password"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          required
          autoComplete="new-password"
        />
        <button type="submit">Sign Up</button>
      </form>
      <div style={{ marginTop: "1rem", fontSize: "0.95rem" }}>
        Already have an account? <Link to="/login">Login</Link>
      </div>
    </div>
  );
}